import React from 'react';
import { Link } from 'react-router-dom';

const PLACEHOLDER_IMG = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600"><rect width="100%" height="100%" fill="#e5e7eb"/><text x="50%" y="50%" text-anchor="middle" fill="#6b7280" font-family="Inter, Arial, sans-serif" font-size="24">AI</text></svg>');

export default function TrendingSidebar({ articles = [] }) {
  return (
    <aside className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Trending</h3>
        <Link to="/search" className="text-xs text-blue-600 hover:underline">View all</Link>
      </div>
      <div className="space-y-4">
        {articles.map((a) => (
          <Link key={a.id} to={`/article/${a.id}`} className="group flex gap-3">
            <div className="w-20 h-20 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">
              <img
                src={a.image_url || PLACEHOLDER_IMG}
                alt={a.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                onError={(e) => { e.currentTarget.src = PLACEHOLDER_IMG; }}
              />
            </div>
            <div className="flex-1">
              <div className="text-xs text-gray-500 mb-1">{a.source}</div>
              <div className="text-sm font-medium text-gray-900 group-hover:text-blue-600 line-clamp-2">
                {a.title}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </aside>
  );
}
